export const percentage = (percent: number, total: number) => ((percent / 100) * total)

export const barterPrice = (barter: number, price: number) => Math.round(price + percentage(barter, price))